__turbopack_context__.v({
  "alignCenter": "cardContent-module__ThxkMa__alignCenter",
  "alignJustify": "cardContent-module__ThxkMa__alignJustify",
  "alignLeft": "cardContent-module__ThxkMa__alignLeft",
  "alignRight": "cardContent-module__ThxkMa__alignRight",
  "body": "cardContent-module__ThxkMa__body",
  "bordered": "cardContent-module__ThxkMa__bordered",
  "buttons": "cardContent-module__ThxkMa__buttons",
  "cardButton": "cardContent-module__ThxkMa__cardButton",
  "clickable": "cardContent-module__ThxkMa__clickable",
  "eyebrow": "cardContent-module__ThxkMa__eyebrow",
  "eyebrowIcon": "cardContent-module__ThxkMa__eyebrowIcon",
  "eyebrowRow": "cardContent-module__ThxkMa__eyebrowRow",
  "filled": "cardContent-module__ThxkMa__filled",
  "header": "cardContent-module__ThxkMa__header",
  "icon": "cardContent-module__ThxkMa__icon",
  "iconAside": "cardContent-module__ThxkMa__iconAside",
  "iconRow": "cardContent-module__ThxkMa__iconRow",
  "iconRowCenter": "cardContent-module__ThxkMa__iconRowCenter",
  "iconRowEnd": "cardContent-module__ThxkMa__iconRowEnd",
  "iconRowReverse": "cardContent-module__ThxkMa__iconRowReverse",
  "iconRowText": "cardContent-module__ThxkMa__iconRowText",
  "iconRowVCenter": "cardContent-module__ThxkMa__iconRowVCenter",
  "iconWrap": "cardContent-module__ThxkMa__iconWrap",
  "iconWrapper": "cardContent-module__ThxkMa__iconWrapper",
  "image": "cardContent-module__ThxkMa__image",
  "padded": "cardContent-module__ThxkMa__padded",
  "priceButtons": "cardContent-module__ThxkMa__priceButtons",
  "priceFeatures": "cardContent-module__ThxkMa__priceFeatures",
  "priceRoot": "cardContent-module__ThxkMa__priceRoot",
  "priceRow": "cardContent-module__ThxkMa__priceRow",
  "root": "cardContent-module__ThxkMa__root",
  "rounded": "cardContent-module__ThxkMa__rounded",
  "testimonialAvatar": "cardContent-module__ThxkMa__testimonialAvatar",
  "testimonialMetaRow": "cardContent-module__ThxkMa__testimonialMetaRow",
  "testimonialMetaText": "cardContent-module__ThxkMa__testimonialMetaText",
  "testimonialName": "cardContent-module__ThxkMa__testimonialName",
  "testimonialQuote": "cardContent-module__ThxkMa__testimonialQuote",
  "testimonialRoot": "cardContent-module__ThxkMa__testimonialRoot",
  "testimonialTitle": "cardContent-module__ThxkMa__testimonialTitle",
  "title": "cardContent-module__ThxkMa__title",
  "titleRow": "cardContent-module__ThxkMa__titleRow",
  "titleRowCenter": "cardContent-module__ThxkMa__titleRowCenter",
  "titleRowEnd": "cardContent-module__ThxkMa__titleRowEnd",
  "underlineOnHover": "cardContent-module__ThxkMa__underlineOnHover",
});
